import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { List, X } from "@phosphor-icons/react";
import { NAV, CONTENT } from "../../data/content";
import { useLang } from "../../context/LanguageContext";
import { scrollToId } from "../../lib/api";

export const Header = () => {
  const { lang, toggle } = useLang();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const t = CONTENT[lang];

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => { setOpen(false); scrollToId(id); };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-[100] transition-colors duration-500 ${
        scrolled ? "backdrop-blur-xl bg-[#050505]/80 border-b border-white/10" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <button data-testid="logo-btn" onClick={() => go("hero")} className="flex items-center gap-2 group">
          <img src="/appforge-logo.png" alt="AppForge Studio" className="w-9 h-9 rounded-lg object-cover group-hover:rotate-6 transition-transform duration-300" />
          <span className="font-heading font-bold text-lg tracking-tight text-white">AppForge <span className="text-blue-500">Studio</span></span>
        </button>

        <nav className="hidden lg:flex items-center gap-7">
          {NAV[lang].map((n) => (
            <button key={n.id} data-testid={`nav-${n.id}`} onClick={() => go(n.id)}
              className="text-sm text-zinc-400 hover:text-white transition-colors duration-200 font-medium">
              {n.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button data-testid="lang-toggle" onClick={toggle}
            className="text-xs font-mono uppercase tracking-widest text-zinc-400 hover:text-white border border-white/15 rounded-full px-3 py-1.5 transition-colors">
            {lang === "it" ? "IT / EN" : "EN / IT"}
          </button>
          <button data-testid="header-cta" onClick={() => go("contatti")}
            className="hidden md:inline-flex items-center rounded-full bg-white text-black text-sm font-semibold px-5 py-2.5 hover:bg-blue-500 hover:text-white transition-colors duration-300">
            {t.ctaConsult}
          </button>
          <button data-testid="mobile-menu-btn" onClick={() => setOpen((o) => !o)} aria-label={open ? "Chiudi menu" : "Apri menu"} className="lg:hidden text-white p-1">
            {open ? <X size={26} /> : <List size={26} />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div data-testid="mobile-menu" initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }} className="lg:hidden overflow-hidden backdrop-blur-xl bg-[#050505]/95 border-b border-white/10">
            <div className="px-6 py-6 flex flex-col gap-1">
              {NAV[lang].map((n) => (
                <button key={n.id} data-testid={`mobile-nav-${n.id}`} onClick={() => go(n.id)}
                  className="text-left text-base text-zinc-200 hover:text-blue-400 py-3 border-b border-white/5 transition-colors">
                  {n.label}
                </button>
              ))}
              <button data-testid="mobile-cta" onClick={() => go("contatti")}
                className="mt-4 rounded-full bg-blue-500 text-white font-semibold px-5 py-3 text-center">
                {t.ctaConsult}
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};
